$('.dropdown-menu__custom .dropdown-submenu .child_level_2').hover(
    function() {
        $( '.dropdown-menu__custom .dropdown-submenu .child_level_2 .dropdown-ssubmenu-wrapper.active' ).removeClass( "active" );
        $( '.dropdown-menu__custom .dropdown-submenu .child_level_2 .tt-title-submenu.active' ).removeClass( "active" );
        $( this ).find('.dropdown-ssubmenu-wrapper').addClass( "active" );
        $( this ).find('.tt-title-submenu').addClass( "active" );
    }
)